import { Box, Button, SvgIcon } from '@mui/material';
import PrintIcon from 'assets/icons/print.svg';
import PrintContent from 'components/@home/drawers/ProfileDrawer/Profile/EmployeeActions/PrintInvitation/PrintContent';
import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import employeeShape from 'shapes/employee';
import { I18n } from 'utils/i18n';

const PrintInvitation = ({ employee }) => {
  const contentRef = useRef();
  const reactToPrintFn = useReactToPrint({ contentRef });

  return (
    <Box sx={{ display: 'flex' }}>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => reactToPrintFn()}
        startIcon={
          <SvgIcon sx={{ marginRight: '5px', color: 'primary.main' }}>
            <PrintIcon />
          </SvgIcon>
        }
      >
        {I18n.t('ProfileDrawer.Print invitation')}
      </Button>
      <div style={{ display: 'none' }}>
        <PrintContent ref={contentRef} employee={employee} />
      </div>
    </Box>
  );
};

PrintInvitation.propTypes = {
  employee: employeeShape.isRequired,
};

export default PrintInvitation;
